import { Component, OnInit, Input } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { PLATFORM_TYPE_INFO, HOUSE_SPACE_TYPE_DESC } from "@root/config";
import _ from "lodash";
import { MultiHouseCalendarService } from "@root/router/house/component/multi-house-calendar/multi-house-calendar.service";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { TranslateService } from "@root/shared/service/translate.service";
import {NzModalService, NzModalRef} from 'ng-zorro-antd/modal';

@Component({
  selector: "host-order-move-house",
  templateUrl: "./order-move-house.component.html",
  styleUrls: ["./order-move-house.component.scss"],
})
export class OrderMoveHouseComponent implements OnInit {
  @Input() codes; // string[] || string
  type;
  houseList = [];
  total = 0;
  page = 1;
  title = "";
  pageSize = 10;
  selected;
  constructor(
    private orderService: OrderV2Service,
    private messageService: NzMessageService,
    private modalService: NzModalService,
    private calendarService: MultiHouseCalendarService,
    private subject: NzModalRef,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.fetchHouseList();
  }

  fetchHouseList() {
    const params = {
      page: this.page,
      page_size: this.pageSize,
      // reservation_code: this.reservation_code,
      house_name: this.title,
    };
    if (!_.isArray(this.codes)) {
      Object.assign(params, {
        reservation_code: this.codes
      });
    }
    this.orderService
      .getChangeHouseList(params)
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.total = res.data.total;
          const houseList = res.data.list;
          this.houseList = this.format(houseList);
        }
      });
  }

  onConfirm () {
    if (_.isArray(this.codes)) {
      this.displayBatchOperateConfirmModal();
    } else {
      this.requestBatchChangeHouse();
    }
  }

  private displayBatchOperateConfirmModal () {
    this.modalService.confirm({
      nzTitle: '确定批量操作？',
      nzContent: '批量操作无法撤销，请先确认无误。',
      nzOnOk: () => {
        this.requestBatchChangeHouse();
      }
    })
  }

  format(houseList) {
    _.forEach(houseList, (house) => {
      const filtered = _.filter(_.values(PLATFORM_TYPE_INFO), { show: true });
      const allPlatforms = _.cloneDeep(_.sortBy(filtered, ["order"]));
      const __picture = _.get(house, "house_picture.small_url");
      const __title =
        _.get(house, "title_alias") ||
        _.get(house, "house_descriptions[0].title") ||
        this.translateService.syncGet(
          "order.change_to_which_house.no_house_name"
        );
      const __type = _.get(house, "relation_platform");
      const __address = _.get(house, "province_name") + _.get(house, "street");
      const __space = this.translateHouseType(_.get(house, "space_type"));
      _.assign(house, {
        platforms: allPlatforms,
        __picture,
        __title,
        __address,
        __space,
        __type,
      });
    });
    return houseList;
  }

  translateHouseType(type) {
    switch (type) {
      case 1:
        // 整套房源
        return this.translateService.syncGet("config.house_space_type.all");
      case 2:
        // 独立单间
        return this.translateService.syncGet("config.house_space_type.alone");
    }
  }

  requestBatchChangeHouse () {
    const params = {
      reservation_codes: _.isArray(this.codes) ? this.codes : [this.codes],
      house_id: this.selected
    };
    this.orderService.batchChangeHouse(params).subscribe(res => {
      if (res.error_code === 0) {
        const successText = this.translateService.syncGet('success.order.order_change_house');
        // 订单换房成功
        this.messageService.success(successText);
        this.subject.destroy({
          refresh: true, // 换房成功后需要回传一个参数，为true代表换房成功，需要刷新
        });
      }
    });
  }

  // @deprecated
  // change() {
  //   const params = {
  //     reservation_code: this.reservation_code,
  //     house_id: this.selected,
  //   };
  //   this.orderService.setChangeToHouse(params).subscribe((res) => {
  //     if (res.error_code === 0) {
  //       // this.calendarService.removeReservation(this.reservation_code);
  //       const successText = this.translateService.syncGet('success.order.order_change_house');
  //       // 订单换房成功
  //       this.messageService.success(successText);
  //       this.subject.destroy({
  //         refresh: true, // 换房成功后需要回传一个参数，为true代表换房成功，需要刷新
  //       });
  //     }
  //   });
  // }
}
